window.Kernel.registerComponent('SearchAddressField', require('./components/SearchAddressField').default);
window.Kernel.registerComponent('Fakeloader', require('./components/Fakeloader').default);